module.exports = __webpack_public_path__ + "static/media/scan.7c1a86fc.svg";